import AurLoadingIndicator from '../aur-loading-indicator/AurLoadingIndictor';

interface Props {
  containerHeight?: number;
  containerClass?: string;
}
const AurDataGridLoadingOverlay: React.FC<Props> = ({
  containerHeight,
  containerClass,
}) => {
  let style = undefined;
  if (containerHeight) style = {height: `${containerHeight}px`};

  return (
    <div
      data-testid="grid-loading-overlay"
      className={`aur-data-grid-loading-overlay-container ${containerClass}`}
      style={style}
    >
      <AurLoadingIndicator show size={40} />
    </div>
  );
};

export default AurDataGridLoadingOverlay;
